import React, { useState, useRef, useEffect } from "react"
import Link from "next/link"
import { useUserContext } from "context/UserContext"
import { useLang } from "hooks/useLang"
import { useRouter } from "next/router"
import useScrollPosition from "hooks/useScrollPosition"
import { useTheme } from "next-themes"

interface IProps {
    allowColorTransition?: boolean
}

export default function SideBarItems({ allowColorTransition }: IProps) {
    const { t, isAr } = useLang()
    const router = useRouter()
    const { theme } = useTheme()
    const { pathname, asPath, query } = router
    const dropdownRef = useRef<HTMLDivElement>(null)

    const [isOpen, setIsOpen] = useState(false)

    const { user, logout } = useUserContext()

    const isDark = theme === "dark"
    const scrollPosition = useScrollPosition()
    const isTop = scrollPosition === 0
    const navItemColor =
        (isTop && isDark) || (!isTop && !isDark) ? "text-white" : "text-white"

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    function LogoutClicked() {
        logout()
        setIsOpen(false)
        location.href = "/"
    }

return (
    <div
        ref={dropdownRef}
        className=" md:flex flex-row items-center gap-2"
        onClick={() => setIsOpen(!isOpen)}
    >
        <div className="relative">
            <h4
                className={`${
                    allowColorTransition
                        ? `${navItemColor} transition-all duration-500`
                        : "text-white"
                } 
                capitalize bg-[#D9D9D9] px-4 py-1 rounded-full 
                font-semibold text-sm tracking-wide cursor-pointer`}
                tabIndex={0}
            >
                {user?.first_name}
            </h4>

            {/* PROFILE */}
            <Link
                href="/user/profile/account"
                className="flex w-full cursor-pointer items-center gap-2 px-3 py-1
                text-xs font-medium capitalize 
                text-black dark:text-[#7C7C7C]
                hover:text-black dark:hover:text-[#F79E1B]"
            >
                {t("profile")}
            </Link>

            {/* TICKETS */}
            <Link
                href="/user/profile/tickets"
                className="flex w-full cursor-pointer items-center gap-2 px-3 py-1
                text-xs font-medium capitalize 
                text-black dark:text-[#7C7C7C]
                hover:text-black dark:hover:text-[#F79E1B]"
            >
                {t("tickets")}
            </Link>

            {/* ORDERS */}
            <Link
                href="/user/profile/orders"
                className="flex w-full cursor-pointer items-center gap-2 px-3 py-1
                text-xs font-medium capitalize 
                text-black dark:text-[#7C7C7C]
                hover:text-black dark:hover:text-[#F79E1B]"
            >
                {t("orders")}
            </Link>

            {/* LOGOUT */}
            <div
                className="flex w-full cursor-pointer items-center gap-2 px-3 py-1
                text-xs font-medium capitalize 
                text-black dark:text-[#7C7C7C]
                hover:text-red-600 dark:hover:text-[#F79E1B]"
                onClick={LogoutClicked}
            >
                {t("logout")}
            </div>
        </div>
    </div>
)



}
